<script lang="ts">
  import { SquareCheck, SquareX } from "lucide-svelte"

  export let role
</script>

<div class="py-6 px-6 text-gray-800">
  {#if role === "full_access"}
    <p class="text-2xl font-bold text-center py-2">Full-Access Member</p>

    <div class="bg-gray-50 rounded border border-blue-100 shadow p-4">
      <p class="text-base">
        The <span class="font-bold">Full-Access Member</span> unlocks all the features
        of the Lead With Purpose platform. This role is perfect for your C-Suite,
        Leadership Team and Department Managers.
      </p>
      <p class="mt-6">
        Each Full-Access Member can be assigned a permission level that will
        allow you to customize the experience for the member to best match their
        role in your organization.
      </p>
      <ul class="list-disc ml-8 mt-4 gap-y-4">
        <li>
          <span class="font-bold">Admin:</span> This role can do anything on your
          plan, including Billing and Members management. This is designed for your
          C-Suite members.
        </li>
        <li class="mt-2">
          <span class="font-bold">Leadership Team:</span> This role is perfect for
          your Leadership Team Members who need access to everything on your plan,
          except the Billing and Member management.
        </li>
        <li class="mt-2">
          <span class="font-bold">Management Team:</span> This role is designed for
          department managers who will be managing goals and tasks, but don't need
          to manage your Plan Settings and run Transition Meetings.
        </li>
      </ul>
    </div>
  {:else if role === "team_member"}
    <p class="text-2xl font-bold text-center py-2">Team Member</p>

    <div class="bg-gray-50 rounded border border-blue-100 shadow p-4">
      <p class="text-base">
        The <span class="font-bold">Team Member</span> role grants access to
        <span class="italic">most</span> of the Lead With Purpose platform.
        These members are able to view everything in the platform but they have
        limited access to management features.
        <span class="font-semibold"
          >For example, Team Members are not able to manage the One Page View or
          Goals.</span
        >
      </p>
      <p class="text-base mt-4">
        This role is designed for those leaders in your organization who need
        the following:
      </p>
      <ul class="list-disc ml-8 mt-1 gap-y-4">
        <li>
          Daily and Weekly Activity reports, to stay on top of what is happening
          within the organization.
        </li>
        <li>The ability to add their own progress on goals and tasks.</li>
        <li>To be able to manage tasks, which help with goal completion.</li>
        <li>To follow along with the Book Readings</li>
        <li>Send and receive Recognitions</li>
        <li>Access to the Lead With Purpose Community</li>
      </ul>
    </div>
  {:else if role === "recognition_member"}
    <p class="text-2xl font-bold text-center py-2">Recognition Member</p>

    <div class="bg-gray-50 rounded border border-blue-100 shadow p-4">
      <p class="text-base">
        The <span class="font-bold">Recognition Member</span> role is a
        <span class="italic">limited role</span>
        that grants the member access to the following:
      </p>
      <ul class="list-disc ml-8 mt-1 gap-y-4">
        <li>View elements of the One Page View</li>
        <li>Send and receive Recognitions</li>
        <li>Access to the Lead With Purpose Community</li>
      </ul>
      <p class="text-base mt-4">
        This role is ideal for members who do not need to be aware of your goals
        and tasks or stay up to date with daily and weekly plan activity. But
        this still keep them connected to your plan and will enable them to be
        empowered and encouraged through the Recognition system.
      </p>
    </div>
  {/if}
</div>
